// React
import { ReactElement } from 'react';
// Next
import { useTranslation } from 'next-i18next';
// Modules
import { usePreventScroll } from '@react-aria/overlays';
// Design System
import { Font } from '@utmb/design-system/text/font';
import { Placeholder } from '@utmb/design-system/placeholder/Placeholder';
// Interfacs
import { ColorTypesEnum } from '@utmb/types/colors';
// Styles
import styles from './my-modal-footer.module.scss';
import { SocialMedia } from '../layout/social-media/SocialMedia';

const MyModalFooter = (): ReactElement => {
    const { t } = useTranslation();
    usePreventScroll();

    return (
        <div className={styles.root}>
            <div className={styles.content_container}>
                <Font.FuturaHeavy mobile="28" desktop="36" className={styles.summary}>
                    {t('myutmb:myUtmb.modalFooter.summary')}
                </Font.FuturaHeavy>
                <SocialMedia className={styles.socials_container} colorTheme={ColorTypesEnum.PRIMARY} />
            </div>
            <div className={styles.picture_container}>
                <Placeholder />
            </div>
        </div>
    );
};

export default MyModalFooter;

/*
const socialLinks = [
    { id: '1', name: 'facebook', icon: IconsEnum.SOCIAL_FACEBOOK, url: 'https://www.facebook.com/UTMBWorldSeries' },
    { id: '2', name: 'instagram', icon: IconsEnum.SOCIAL_INSTAGRAM, url: 'https://www.instagram.com/utmbworldseries/' },
    { id: '3', name: 'twitter', icon: IconsEnum.SOCIAL_TWITTER, url: 'https://twitter.com/utmbworldserie' },
    { id: '4', name: 'youtube', icon: IconsEnum.SOCIAL_YOUTUBE, url: 'https://www.youtube.com/c/UTMBWorldSeries' },
    { id: '5', name: 'strava', icon: IconsEnum.SOCIAL_STRAVA, url: 'https://www.strava.com/clubs/ultra-trail%C2%AE-world-tour-228759?' },
];*/
